import React from 'react';

import UserAvatar from '../UserAvatar';

import { getInitials } from '../../helpers';

import type { Memory } from '../../types/memory';

const MemorySharedBy: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <div className="memory-shared-by wa-cluster wa-gap-xs">
      <UserAvatar profile={{ initials: getInitials(memory.name) }} />
      Shared by {memory.name}
    </div>
  );
}

export default MemorySharedBy;
